import React, { Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import 'moment-duration-format';

export default class DurationCountdown extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
		this.timerID = setInterval(
			() => this.tick(),
			1000
		);
	}

	componentWillUnmount() {
		clearInterval(this.timerID);
	}

	formatDurationSeconds = (d) => {
		return moment.duration(d).format('d [days], h [hours], m [minutes], s [seconds]');
	};

	tick() {
		const { startMoment, handleCountdownDone} = this.props;
		const duration = moment.duration(startMoment.diff(moment()));

		if (duration.asSeconds() <= 0) {
			clearInterval(this.timerID);
			handleCountdownDone();
		}
		this.setState({ duration });
	}

	render() {
		const { duration } = this.state;
		if (!duration) {
			return '...';
		}

		if (duration.asSeconds() <= 0) {
			return ('Ready to rock!');
		}

		return (
			<Fragment>
				{this.formatDurationSeconds(duration)}
			</Fragment>
		);
	}
}

DurationCountdown.propTypes = {
	startMoment : PropTypes.object.isRequired,
	handleCountdownDone : PropTypes.func.isRequired,
};
